var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { getNumber, getUnit } from './Border/borderUtils';
import StyleConfTemplate from './StyleConfTemplate';
import SizeInput from './widgets/sizeInput';
import StylePanelMixin from '../utils/StylePanelMixin';
let Effects = class Effects extends StylePanelMixin {
  handleOpacityValueChange(value) {
    if (typeof value === 'string') {
      this.setStyle('opacity', parseFloat(value));
    } else {
      this.setStyle('opacity', value);
    }
  }
  get opacity() {
    return this.style.opacity === undefined ? 1 : this.style.opacity;
  }
  get filterStyle() {
    return (this.style.filter || '').split(' ').reduce((acc, cur) => {
      if (!cur) return acc;
      const key = cur.split('(')[0];
      const val = cur.split('(')[1].split(')')[0];
      acc[key] = val;
      return acc;
    }, {});
  }
  changeFilter(key, value) {
    if (key in this.filterStyle) {
      if (value === null) {
        if (Object.keys(this.filterStyle).length === 1) {
          this.deleteStyle('filter');
        } else {
          this.setStyle('filter', this.style.filter.replace(`${key}(${this.filterStyle[key]})`, '').trim());
        }
      } else {
        var _this$style$filter;
        this.setStyle('filter', (_this$style$filter = this.style.filter) === null || _this$style$filter === void 0 ? void 0 : _this$style$filter.replace(`${key}(${this.filterStyle[key]})`, `${key}(${value})`));
      }
    } else {
      this.setStyle('filter', `${this.style.filter || ''} ${key}(${value})`);
    }
  }
  filterChanged(key, defaultValue) {
    return !!this.filterStyle[key] && this.filterStyle[key] !== defaultValue;
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "uc-slider-input-rapper"
    }, [h(StyleConfTemplate, {
      "attrs": {
        "name": "透明度",
        "changed": this.changedFromDefault('opacity', 1),
        "inline": true
      },
      "on": {
        "reset": () => this.deleteStyle('opacity')
      }
    }, [h("div", {
      "class": "uc-stylePanel-sliderInput-wrapper"
    }, [h("a-slider", {
      "class": "uc-stylePanel-inline-slider",
      "attrs": {
        "min": 0,
        "max": 1,
        "step": 0.1,
        "value": +this.opacity
      },
      "on": {
        "change": this.handleOpacityValueChange
      }
    }), h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "value": `${this.opacity}`,
        "unit": "%",
        "placeholder": "1",
        "fixed-unit": true,
        "step": 0.1
      },
      "on": {
        "change": this.handleOpacityValueChange
      }
    })])]), h(StyleConfTemplate, {
      "attrs": {
        "name": "模糊",
        "changed": this.filterChanged('blur', '0px'),
        "inline": true
      },
      "on": {
        "reset": () => this.changeFilter('blur', null)
      }
    }, [h("div", {
      "class": "uc-stylePanel-sliderInput-wrapper"
    }, [h("a-slider", {
      "class": "uc-stylePanel-inline-slider",
      "attrs": {
        "min": 0,
        "max": 10,
        "value": +getNumber(this.filterStyle.blur)
      },
      "on": {
        "change": val => this.changeFilter('blur', `${val}${getUnit(this.filterStyle.blur)}`)
      }
    }), h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "value": getNumber(this.filterStyle.blur),
        "unit": getUnit(this.filterStyle.blur),
        "placeholder": "1",
        "fixed-unit": true
      },
      "on": {
        "change": val => this.changeFilter('blur', val)
      }
    })])]), h(StyleConfTemplate, {
      "attrs": {
        "name": "亮度",
        "changed": this.filterChanged('brightness', '100%'),
        "inline": true
      },
      "on": {
        "reset": () => this.changeFilter('brightness', null)
      }
    }, [h("div", {
      "class": "uc-stylePanel-sliderInput-wrapper"
    }, [h("a-slider", {
      "class": "uc-stylePanel-inline-slider",
      "attrs": {
        "min": 0,
        "max": 200,
        "step": 10,
        "value": +getNumber(this.filterStyle.brightness, '100')
      },
      "on": {
        "change": val => this.changeFilter('brightness', `${val}%`)
      }
    }), h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "value": `${+getNumber(this.filterStyle.brightness, '100')}`,
        "unit": "%",
        "placeholder": "1",
        "fixed-unit": true,
        "step": 10
      },
      "on": {
        "change": val => this.changeFilter('brightness', val)
      }
    })])]), h(StyleConfTemplate, {
      "attrs": {
        "name": "对比度",
        "changed": this.filterChanged('contrast', '100%'),
        "inline": true
      },
      "on": {
        "reset": () => this.changeFilter('contrast', null)
      }
    }, [h("div", {
      "class": "uc-stylePanel-sliderInput-wrapper"
    }, [h("a-slider", {
      "class": "uc-stylePanel-inline-slider",
      "attrs": {
        "min": 0,
        "max": 200,
        "step": 10,
        "value": +getNumber(this.filterStyle.contrast, '100')
      },
      "on": {
        "change": val => this.changeFilter('contrast', `${val}%`)
      }
    }), h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "value": `${+getNumber(this.filterStyle.contrast, '100')}`,
        "unit": "%",
        "placeholder": "1",
        "fixed-unit": true,
        "step": 10
      },
      "on": {
        "change": val => this.changeFilter('contrast', val)
      }
    })])])]);
  }
};
Effects = __decorate([Component({
  name: 'SPEffects'
})], Effects);
export default Effects;
//# sourceMappingURL=effects.js.map
